import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { UiWidgetsService } from "./ui-widgets.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuditStatsService {
    private baseUrl: string;

  constructor(
    @Inject('environment') environment,
    private http: HttpClient,
    private uiWidgetsService: UiWidgetsService
  ) {
    this.baseUrl = environment.ddwaBaseUrl;
  }

  public getIndustryAuditStatsData(params?: any): Observable<any> {
    const paramsWithTimestamp = { ...params, _t: Date.now() };
    const httpParams = new HttpParams({fromObject: paramsWithTimestamp});
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    });
    return this.http.get(`${this.baseUrl}auditStats/getAuditLogStatistics`, { params: httpParams, headers });
  }

  public getFirmAuditStatsData(params?: any): Observable<any> {
    const paramsWithTimestamp = { ...params, _t: Date.now() };
    const httpParams = new HttpParams({fromObject: paramsWithTimestamp});
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    });
    return this.http.get(`${this.baseUrl}auditStatsReportLevel/getAuditLogStatistics`, { params: httpParams, headers });
  }
}